module.exports = __webpack_public_path__ + "static/searchinput-irrelevant-info-dont-afa52f32d938c1bb01f5822afcab90c6.png";